import React, { useRef, useState } from "react";
import { Box, Button, CircularProgress, Fade, Skeleton, Typography, useMediaQuery } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./../../theme/IntroCarousel.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight } from "@fortawesome/pro-light-svg-icons";
import theme from "../../theme/theme";
import { Link as RouterLink } from "react-router-dom";

const CustomDots = ({ slides, currentSlide, goToSlide}) => {
  return (
    <div className="custom-dots">
      {slides.map((_, index) => (
        <span
          key={index}
          onClick={() => goToSlide(index)}
          className={`custom-dot ${currentSlide === index ? "active" : ""}`}
        ></span>
      ))}
    </div>
  );
};

const IntroCarousel = ({ slides, loading }) => {

  const mobile=useMediaQuery(theme=>theme.breakpoints.down('md'));

  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (oldIndex, newIndex) => {
      setCurrentSlide(newIndex);
    },
  };

  const goToSlide = (index) => {
    sliderRef.current.slickGoTo(index);
    setCurrentSlide(index);
  };
  
  return (
    <>
      <Box
        sx={{
          position: "relative",
        }}
      >
        {loading ?
          <Box
            sx={{
              position: "relative",
              height: 'calc('+window.innerHeight+'px - 100px)',
              width: "100vw",
              backgroundColor: "#f5f5f5",
            }}
            variant="rectangular"
          >
            <CircularProgress
              color="primary"
              sx={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)", // Center the CircularProgress
                width: "100%",
                height: "100%",
              }}
            />
          </Box>

        : slides && slides.length > 0 ?
          <>
            <Box
                sx={{
                    position: "absolute",
                    left: "0%",
                    bottom: "6px",
                    display: "flex",
                    flexDirection: mobile? 'column' : 'row',
                    zIndex: "1",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "stretch",
                }}
            >
              <Fade in={true} timeout={3000}>
                <Box
                    sx={{
                        width: mobile? '100%' : "50%",
                        backgroundColor: "rgba(233, 83, 28, .9)",
                        cursor: "pointer",
                    }}
                    className="hover-box"
                    component={RouterLink}
                    to={"/services/consulting/"}
                >
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: mobile? '1.4rem' : '2vw',
                        fontWeight: "bold",
                        textDecoration: "none",
                        padding:{
                          xs:'0.5rem',
                          md:'1rem'
                        },
                        textAlign: {
                          xs: "left",
                          md: "center",
                        },
                        '& > a':{
                          textDecoration: "none",
                        },
                      }}
                    >
                        S2 Consultancy Services
                        <FontAwesomeIcon 
                          icon={faArrowCircleRight} 
                          style={{
                            marginLeft: "15px",
                            transition: "transform 0.1s ease",
                            float: {
                              xs: "right",
                              md: "none",
                            },
                            marginTop: {
                              xs: "-8px",
                              md: "0",
                            },
                          }}
                          className="bob-right-left"
                        />
                    </Typography>
                </Box>
              </Fade>
              <Fade in={true} timeout={3500}>
                <Box
                    sx={{
                        width: mobile? '100%' : "50%",
                        backgroundColor: "rgba(0, 94, 170, .9)",
                        cursor: "pointer",
                    }}
                    className="hover-box"
                    component={RouterLink}
                    to={"/services/s2-riskwise-software/"}
                >
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: mobile? '1.4rem' : '2vw',
                        fontWeight: "bold",
                        textDecoration: "none",
                        padding:{
                          xs:'0.5rem',
                          md:'1rem'
                        },
                        textAlign: {
                          xs: "left",
                          md: "center",
                        },
                        '& > a':{
                          textDecoration: "none",
                        },
                      }}
                    >
                        S2 RiskWise Software
                        <FontAwesomeIcon 
                          icon={faArrowCircleRight} 
                          style={{
                            marginLeft: "15px",
                            transition: "transform 0.1s ease",
                            float: {
                              xs: "right",
                              md: "none",
                            },
                            marginTop: {
                              xs: "-8px",
                              md: "0",
                            },
                          }}
                          className="bob-right-left"
                        />
                    </Typography>

                </Box>
              </Fade>
            </Box>
          
            <Slider ref={sliderRef} {...settings}>
              {slides.map((slide, index) => {
                const isVideo = slide.media.match(/\.(mp4|mov|avi|wmv)$/) != null;

                return (
                  <Fade in={true}>
                    <Box
                      key={index}
                      sx={
                        isVideo
                          ? {
                              height: 'calc('+window.innerHeight+'px - 100px)',
                              width: "100vw",
                              position: "relative",
                            }
                          : {
                              height: 'calc('+window.innerHeight+'px - 100px)',
                              width: "100vw",
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                              backgroundImage: `url(${slide.media})`,
                              position: "relative",
                            }
                      }
                    >
                      {isVideo && (
                        <video
                          src={slide.media}
                          autoPlay
                          muted
                          loop
                          style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            zIndex: "-1",
                          }}
                        />
                      )}
                      <Box
                        sx={{
                          position: "absolute",
                          left: "0%",
                          width: {
                            xs: "90%",
                            lg: "70%",
                          },
                          margin: "0 auto",
                          padding: "0 7% 0 0",
                          zIndex: "1",
                          background: "rgb(13,96,168)",
                          background:
                            "linear-gradient(90deg, rgba(13,96,168,0.9) 60%, rgba(0,0,0,0) 100%)",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          mixBlendMode: "multiply",
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          width: '92%',
                          height: '100%',
                          maxWidth: `${theme.width.maxwidth}`,
                          left: '50%',
                          transform: 'translate(-50%)',
                          zIndex: '1',
                        }}
                      >
                        <Box
                          sx={{
                            position: "absolute",
                            left: "0%",
                            width:'100%',
                            //maxWidth: "1000px",
                            margin: "0 auto",
                           //padding: "0 7% 0 0",
                            zIndex: "1",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: {
                              xs: "flex-start",
                              md: "center",
                            },
                            alignItems: "flex-start",
                          }}
                        >
                          <CustomDots
                            slides={slides}
                            currentSlide={currentSlide}
                            goToSlide={goToSlide}
                          />
                          <Fade in={true} timeout={1000}>
                            <Typography
                              variant="h3"
                              sx={{
                                fontSize:{
                                  xs:'5vh',
                                  md:'max(5vh, 50px)'
                                },
                                // fontSize: {
                                //   xs: "2.3rem",
                                //   md: "2.8rem",
                                // },
                                color: "#ffffff",
                                marginTop:{
                                  xs:'3rem',
                                  md:0
                                },
                                mb:{
                                  xs:'1rem',
                                  md:'2rem'
                                },
                                width:{
                                  xs:'100%',
                                  sm:'70%'
                                }
                                //maxWidth: "630px",
                              }}
                            >
                              {slide.title}
                            </Typography>
                          </Fade>
                          {/*slide.button_link*/}
                          <Fade in={true} timeout={2000}>
                            <Button
                              sx={{
                                color: "#ffffff",
                                border: "2px solid #ffffff",
                                borderRadius: "30px",
                                cursor: "pointer",
                                padding:{
                                  xs:'0.25rem 0.5rem',
                                  md:'0.5rem 1rem'
                                },
                                fontSize:{
                                  xs:'1rem',
                                  md:'1.2rem'
                                },
                                position: "relative",
                                transition: "all 0.2s ease-in-out",
                                overflow: "hidden",
                                fontWeight: "400",
                                "&::after": {
                                  content: "''",
                                  position: "absolute",
                                  zIndex: "-1",
                                  transition: "all 0.2s ease-in-out",
                                  width: "100%",
                                  height: "0%",
                                  top: "0",
                                  left: "0",
                                  backgroundColor: "rgba(255,114,28,0.7)",
                                },
                                "&:hover": {
                                  "&::after": {
                                    height: "100%",
                                  },
                                },
                              }}
                              component={RouterLink}
                              to={slide.button_link}
                            >
                              {slide.button_text}
                            </Button>
                          </Fade>
                        </Box>
                        </Box>
                    </Box>
                  </Fade>
                );
              })}
            </Slider>
          </>
        : null}
       </Box>
    </>
  );
};

export default IntroCarousel;
